import React from 'react';
import { motion } from 'framer-motion';
export function Story() {
  return <section className="py-32 relative overflow-hidden" data-id="element-289">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-290">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-5xl font-bold mb-8" data-id="element-291">
          Your business already has the answers.
          <br data-id="element-292" />
          <span className="text-textSecondary" data-id="element-293">
            They're just impossible to see.
          </span>
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-lg text-textSecondary max-w-xl mx-auto" data-id="element-294">
          <p data-id="element-295">
            They're scattered across a dozen tools. We bring them into one
            place.
          </p>
          <p className="text-white font-medium text-2xl pt-6" data-id="element-296">
            One source of truth.
          </p>
        </motion.div>
      </div>
    </section>;
}